export default "__VITE_ASSET__CxAMlwUv__"